import { takeEvery, call, put, fork } from 'redux-saga/effects';
import { loadHizmet, saveHizmet } from 'src/utils/storage/Defect';
import * as actions from '../actions/defectActions';
import * as api from '../api/afterSalesDataServices';

function* getDefects(kulModelKodu, garantiTipi, WorkOrderDetails) {
  try {
    if (!kulModelKodu.kulModelKodu) {
      throw new Error('Model Kodu Girilmemiş');
    }

    let data = loadHizmet(kulModelKodu.kulModelKodu);

    const result = yield call(api.getDefects, kulModelKodu, garantiTipi);
    data = result.data === '' ? [] : result.data;
    saveHizmet(kulModelKodu.kulModelKodu, data);
    const selectedDefects = [];
    if (data.length > 0) {
      arguments[0].WorkOrderDetails.forEach(function(h, index) {
        selectedDefects.push(h.DefectId);
      });
    }

    yield put(actions.getDefectSuccess(data, selectedDefects));
  } catch (error) {
    yield put(actions.setDefectError(error));
  }
}

function* watchGetDefectRequest() {
  yield takeEvery(actions.Types.GET_DEFECT_REQUEST, getDefects);
}

const defectSagas = [fork(watchGetDefectRequest)];

export default defectSagas;
